export enum MaskTypeEnum {
  cpf = 'cpf',
  date = 'date',
  number = 'number',
  cnpj = 'cnpj',
  time = 'time',
}
